import type { Project } from '@/types/content'
import { ProjectCard } from './ProjectCard'
import styles from './ProjectGrid.module.css'

export function ProjectGrid({ projects }: { projects: Project[] }) {
  if (projects.length === 0) {
    return <p className={styles.empty}>No projects match that filter yet.</p>
  }

  return (
    <ul className={styles.grid}>
      {projects.map((project) => (
        <li key={project.slug}>
          <ProjectCard project={project} />
        </li>
      ))}
    </ul>
  )
}
